import { getUnreadChatroomCount } from './selector.unread-chatroom-count';
import _isEqual from 'lodash/isEqual';
import ConnectivityService from '../../services/connectivity.service';
// TODO delete this module along with all directory and replace w/ v2 once specs.chat.SdkUnreadBreakdown is merged
var UnreadChatroomCountApi = /** @class */ (function () {
    function UnreadChatroomCountApi(_a) {
        var store = _a.store, actions = _a.actions;
        this.store = store;
        this.actions = actions;
    }
    UnreadChatroomCountApi.prototype.subscribe = function (callback, filter) {
        var _this = this;
        var prevRes;
        var storeCallback = function () {
            var state = _this.store.getState();
            var res = getUnreadChatroomCount(state, filter);
            if (res && !_isEqual(prevRes, res)) {
                prevRes = res;
                callback(res);
            }
        };
        storeCallback();
        ConnectivityService.waitForOnline.then(function () { return _this.store.dispatch(_this.actions.fetchAndUpdateUnreadChatrooms(filter)); });
        return {
            unsubscribe: this.store.subscribe(storeCallback),
        };
    };
    return UnreadChatroomCountApi;
}());
export default UnreadChatroomCountApi;
